import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import "./scss/index.scss";
import * as React from "react";
import { FormattedMessage } from "react-intl";
import { Link, NavLink } from "react-router-dom";
import ReactSVG from "react-svg"; // import { commonMessages } from "@temp/intl";

import { CachedImage } from "@components/molecules";
import { useOrdersInProgressAmountByUser } from "@saleor/sdk"; // import { userInfo } from "os";

import { baseUrl } from "../../app/routes";
import * as paths from "../../app/routes/paths";
import { maybe } from "../../core/utils";
import NavItem from "./NavItem";
import backImg from "../../images/arrow-back.svg"; // import logoImg from "../../images/logo-ep-ai-red.svg";

import closeImg from "../../images/closewhite.svg";
import menuImg from "../../images/menuwhite.svg";
import shopImage from "../../images/nav/shop.svg";
import hallWaysImage from "../../images/nav/aisles.svg";
import offersImage from "../../images/nav/offers.svg";
import logoImg from "../../images/logo-ep-ai-red.svg"; // const favoritesImage = require("../../images/nav/favorites.svg");

import profileImage from "../../images/nav/profile.svg";
import restaurantImage from "../../images/nav/restaurant.svg";
import myOrdersImage from "../../images/myOrdersImgDesktop.svg";
import AlertLogin from "../AlertLogin";

var NavItemMenu = function NavItemMenu(props) {
  var className = props.className || "side-nav__menu-item-options-link";
  var color = props.linkTo === window.location.pathname ? "yellow" : "white";
  var classNameLabel = props.linkTo === window.location.pathname ? "active" : "";

  var _useOrdersInProgressA = useOrdersInProgressAmountByUser({
    fetchPolicy: "network-only"
  }),
      dataOrderInProgressAmount = _useOrdersInProgressA.data,
      loadingOrderInProgressAmount = _useOrdersInProgressA.loading;

  return React.createElement(NavLink, {
    to: props.linkTo,
    className: className,
    onClick: function onClick(e) {
      if (props.handleOnClick) {
        props.handleOnClick(e);
      }
    }
  }, React.createElement(ReactSVG, {
    path: props.svgPath,
    svgStyle: {
      fill: color
    }
  }), React.createElement("span", {
    className: classNameLabel
  }, props.label), dataOrderInProgressAmount !== null && dataOrderInProgressAmount.ordersInProgressAmount > 0 && !loadingOrderInProgressAmount && props.linkTo === paths.orderHistoryUrl && React.createElement("div", null, React.createElement("p", {
    className: "side-nav__orderInProgress"
  }, dataOrderInProgressAmount.ordersInProgressAmount)));
};

var NavList = /*#__PURE__*/function (_React$PureComponent) {
  _inherits(NavList, _React$PureComponent);

  function NavList() {
    var _getPrototypeOf2;

    var _temp, _this;

    _classCallCheck(this, NavList);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _possibleConstructorReturn(_this, (_temp = _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(NavList)).call.apply(_getPrototypeOf2, [this].concat(args))), _this.state = {
      displayedItems: _this.props.items,
      parent: null,
      showAlertLogin: false,
      user: _this.props.user,
      withOutCategory: false
    }, _this.handleShowSubItems = function (item) {
      _this.setState(_objectSpread(_objectSpread({}, _this.state), {}, {
        parent: item,
        displayedItems: item.children
      }));
    }, _this.handleGoBack = function () {
      var grandparent = _this.state.parent.parent;

      if (!grandparent) {
        _this.setState({
          parent: null,
          displayedItems: _this.props.items
        });
      } else {
        var newParent = _this.findItemById(grandparent.id);

        _this.setState({
          displayedItems: newParent.children,
          parent: newParent
        });
      }
    }, _this.restaurant = function (user) {
      var indexFinalData = user.currentTrade.tradeTypes.findIndex(function (data) {
        return data.uniqueType.includes(5);
      });

      if (indexFinalData !== -1) {
        return true;
      }

      return false;
    }, _this.handleOnClickSaleLink = function () {
      localStorage.setItem("sale_search_clean", " true");
    }, _this.handleOnClickHomeLink = function () {
      localStorage.setItem("home_search_clean", " true");
    }, _temp));
  }

  _createClass(NavList, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var oneSubcategory = localStorage.getItem("oneSubcategory");

      if (oneSubcategory) {
        this.setState(function (prevState) {
          return _objectSpread(_objectSpread({}, prevState), {}, {
            withOutCategory: true
          });
        });
      }

      if (!oneSubcategory) {
        this.setState(function (prevState) {
          return _objectSpread(_objectSpread({}, prevState), {}, {
            withOutCategory: false
          });
        });
      }
    }
  }, {
    key: "findItemById",
    value: function findItemById(id) {
      var match = null;

      function find(item) {
        if (item.id === id) {
          match = item;
          return true;
        }

        return item.children && item.children.some(find);
      }

      this.props.items.some(find);
      return match;
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var hideOverlay = this.props.hideOverlay;
      var _this$state = this.state,
          displayedItems = _this$state.displayedItems,
          parent = _this$state.parent;
      var restaurantValue = this.restaurant(this.state.user);
      return React.createElement("ul", {
        className: "side-nav__menu"
      }, parent ? React.createElement("li", {
        className: "side-nav__menu-item side-nav__menu-item-back"
      }, React.createElement("span", {
        onClick: this.handleGoBack
      }, React.createElement(ReactSVG, {
        path: backImg
      }), " ", parent.name)) : React.createElement(React.Fragment, null, React.createElement("div", {
        className: "side-nav__menu-first"
      }, React.createElement("li", {
        className: "side-nav__menu-item side-nav__menu-item--parent"
      }, React.createElement(Link, {
        to: baseUrl,
        onClick: hideOverlay
      }, React.createElement(ReactSVG, {
        path: menuImg
      })), React.createElement("span", {
        onClick: hideOverlay
      }, React.createElement(ReactSVG, {
        path: closeImg
      }))), React.createElement("li", {
        className: "side-nav__menu-item side-nav__menu-item-profile"
      }, React.createElement(Link, {
        to: paths.baseUrl
      }, this.state.user.currentTrade.logoImage ? React.createElement(CachedImage, {
        url: maybe(function () {
          return _this2.state.user.currentTrade.logoImage.url;
        }),
        alt: maybe(function () {
          return _this2.state.user.currentTrade.logoImage.alt ? _this2.state.user.currentTrade.logoImage.alt : "";
        }, "")
      }, React.createElement(React.Fragment, null)) : React.createElement(ReactSVG, {
        path: logoImg
      }), this.state.user.currentTrade.name && React.createElement("h5", null, this.state.user.currentTrade.name))), React.createElement("li", {
        className: "side-nav__menu-item-options"
      }, restaurantValue ? React.createElement(NavItemMenu, {
        label: React.createElement(FormattedMessage, {
          id: "components.MobileNav.NavList.1119152923",
          defaultMessage: "Menu"
        }),
        linkTo: paths.baseUrl,
        svgPath: restaurantImage,
        handleOnClick: function handleOnClick() {
          return _this2.handleOnClickHomeLink();
        }
      }) : React.createElement(NavItemMenu, {
        label: React.createElement(FormattedMessage, {
          id: "components.MobileNav.NavList.3069060397",
          defaultMessage: "Shop"
        }),
        linkTo: paths.baseUrl,
        svgPath: shopImage,
        handleOnClick: function handleOnClick() {
          return _this2.handleOnClickHomeLink();
        }
      }), restaurantValue && !this.state.withOutCategory ? React.createElement(NavItemMenu, {
        label: React.createElement(FormattedMessage, {
          id: "components.MobileNav.NavList.3583204912",
          defaultMessage: "Categories"
        }),
        linkTo: paths.categoriesUrl,
        svgPath: hallWaysImage
      }) : !this.state.withOutCategory && React.createElement(NavItemMenu, {
        label: React.createElement(FormattedMessage, {
          id: "components.MobileNav.NavList.3583204912",
          defaultMessage: "Categories"
        }),
        linkTo: paths.categoriesUrl,
        svgPath: hallWaysImage
      }), React.createElement(NavItemMenu, {
        label: React.createElement(FormattedMessage, {
          id: "components.MobileNav.NavList.468441986",
          defaultMessage: "Sale"
        }),
        linkTo: paths.saleUrl,
        svgPath: offersImage,
        handleOnClick: function handleOnClick() {
          return _this2.handleOnClickSaleLink();
        }
      }), React.createElement(NavItemMenu, {
        label: React.createElement(FormattedMessage, {
          id: "components.MobileNav.NavList.1534468327",
          defaultMessage: "Profile"
        }),
        linkTo: paths.accountUrl,
        handleOnClick: function handleOnClick(e) {
          var _this2$state$user;

          if ((_this2$state$user = _this2.state.user) === null || _this2$state$user === void 0 ? void 0 : _this2$state$user.isAnonymousUser) {
            e.preventDefault();

            _this2.setState(function (prevState) {
              return _objectSpread(_objectSpread({}, prevState), {}, {
                showAlertLogin: true
              });
            });
          }
        },
        svgPath: profileImage
      }), React.createElement(NavItemMenu, {
        label: React.createElement(FormattedMessage, {
          id: "components.MobileNav.NavList.2364847682",
          defaultMessage: "Orders"
        }),
        linkTo: paths.orderHistoryUrl,
        handleOnClick: function handleOnClick(e) {
          var _this2$state$user2;

          if ((_this2$state$user2 = _this2.state.user) === null || _this2$state$user2 === void 0 ? void 0 : _this2$state$user2.isAnonymousUser) {
            e.preventDefault();

            _this2.setState(function (prevState) {
              return _objectSpread(_objectSpread({}, prevState), {}, {
                showAlertLogin: true
              });
            });
          }
        },
        svgPath: myOrdersImage,
        className: "side-nav__menu-item-options-order"
      })))), displayedItems.map(function (item) {
        return React.createElement(NavItem, _extends({
          key: item.id,
          hideOverlay: hideOverlay,
          showSubItems: _this2.handleShowSubItems
        }, item));
      }), this.state.showAlertLogin && React.createElement(AlertLogin, {
        hideModal: function hideModal() {
          return _this2.setState(function (prevState) {
            return _objectSpread(_objectSpread({}, prevState), {}, {
              showAlertLogin: false
            });
          });
        }
      }));
    }
  }]);

  return NavList;
}(React.PureComponent);

export default NavList;